<template>
    <b-notification v-if="message" v-on:close="$emit('update:message', '')"
                    :type="type"
                    aria-close-label="Close notification" role="alert">
        {{message}}
    </b-notification>
</template>

<script>
    import BNotification from "buefy/src/components/notification/Notification";
    export default {
        name: "HcpNotification",
        components: {BNotification},
        props: {
            type: String,
            message: String,
        },
    }
</script>

<style scoped>

</style>